import { IClassNameProps } from '@bem-react/core';
import { Attributes } from 'react';

import cn from 'utils/cn';

import Level from './level';

export interface ILevelProps extends IClassNameProps, Attributes {}

export const cnLevel = cn('level');

export default Level;
